// src/redux/Providers.tsx
"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Provider } from "react-redux";
import { store } from "./store";
import React, { useState } from "react";

export function QueryProviders({ children }: { children: React.ReactNode }) {
    const [queryClient] = useState(() => new QueryClient());

    return (
        <QueryClientProvider client={queryClient}>
            {children}
            {process.env.NODE_ENV === "development" ? (
                <ReactQueryDevtools initialIsOpen={false} />
            ) : null}
        </QueryClientProvider>
    );
}

export function ReduxProviders({ children }: { children: React.ReactNode }) {
    return <Provider store={store}>{children}</Provider>;
}

export function Providers({ children }: { children: React.ReactNode }) {
    return (
        <QueryProviders>
            <ReduxProviders>{children}</ReduxProviders>
        </QueryProviders>
    );
}
